import { Field } from 'redux-form';
import styles from './styles.css';
import { lazy, Suspense } from 'react';

const Editor = lazy(() => import('./editor'));

const setOptions = {
  enableBasicAutocompletion: false,
  enableLiveAutocompletion: true,
  enableSnippets: false,
  showLineNumbers: true,
  tabSize: 2,
  wrapBehavioursEnabled: true,
  wrap: true,
  useSoftTabs: true,
};

export const Component = ({
  language = 'css',
  style,
  input: { onBlur, ...input },
}: any) => (
  <Suspense fallback={null}>
    <Editor
      {...input}
      theme="xcode"
      mode={language}
      width="100%"
      showPrintMargin
      showGutter
      enableLiveAutocompletion
      enableBasicAutocompletion
      editorProps={{ $blockScrolling: true }}
      setOptions={setOptions}
    />
  </Suspense>
);

export const CodeEditor = (props) => (
  <div className={styles.root} style={props.style}>
    <Field component={Component} {...props} />
  </div>
);
